(function () {
    'use strict';

    angular.module('app').controller('PrepaidController', PrepaidController);

    PrepaidController.$inject = [
        '$rootScope', '$scope', '$routeParams', 'LANGS', '$timeout', '$location', '$filter',
        'blockUI', '$uibModal',
        'PrepaidService', 'NotifyService', 'SelectService', 'POSService', 'SettingsService', 'ExportService'];

    function PrepaidController($rootScope, $scope, $routeParams, LANGS, $timeout, $location, $filter,
                               blockUI, $uibModal,
                               PrepaidService, NotifyService, SelectService, POSService, SettingsService, ExportService) {

        $scope.getTimezonesList = SelectService.getTimezonesList;
        $scope.modals = {};
        $scope.error = {};
        $scope.params = {
            details: {
                tab: 'cards'
            },
            series: {
                showDisabled: false,
                page: 1,
                count: 20
            },
            cards: {
                page: 1,
                count: 50,
                active: 0
            },
            categories: {
                showDisabled: false
            },
            services: {
                showDisabled: false
            },
            accounts: {
                showDisabled: false
            },
            codes: {
                page: 1,
                count: 20
            }
        };

        $scope.data = {
            isFilePreparing: false,
            image: {
                src: '',
                cropped: '',
                new: false
            },
            codes_list_import: [],
            summary: {},
            couponsGeneration: {
                status: false,
                progress: 0
            },
            pagerLengths: [10, 20, 50, 100, 200]
        };

        $scope.cards_table_cols = [
            {
                visible: true,
                data: [
                    {value: 'code', text: 'COL_PREPAID_CARD_CODE', visible: true}
                ]
            },
            {
                visible: true,
                data: [
                    {value: 'emitted_dt', text: 'emission_dt', visible: true},
                    {value: 'expire_dt', text: 'COL_PREPAID_CARD_EXPIRED_DATE', visible: true}
                ]
            },
            {
                visible: true,
                data: [
                    {value: 'active', text: 'COL_PREPAID_CARD_ACTIVE', visible: true},
                    {value: 'activated_dt', text: 'activated_dt', visible: true}

                ]
            },
            {
                visible: true,
                data: [
                    {value: 'user_id', text: 'Customer', visible: true},
                    {value: 'referral_code', text: 'Referral code', visible: true}
                ]
            },
            {
                visible: true,
                data: [
                    {value: 'canceled', text: 'COL_PREPAID_CARD_CANCELED', visible: true}
                ]
            }
        ];

        var pageTitles = {
            series: 'TEXT_PREPAID_SERIES_TITLE',
            cards: 'TEXT_PREPAID_TITLE',
            accounts: 'TEXT_PREPAID_ACCOUNTS_TITLE',
            categories: 'TEXT_PREPAID_CATEGORIES_TITLE',
            services: 'TEXT_PREPAID_SERVICES_TITLE',
            create: 'TEXT_PREPAID_CREATE_TITLE',
            'account-create': 'TEXT_PREPAID_ACCOUNT_CREATE_TITLE',
            'category-create': 'TEXT_PREPAID_CATEGORY_CREATE_TITLE',
            'service-create': 'TEXT_PREPAID_SERVICE_CREATE_TITLE',
            'series-create': 'TEXT_PREPAID_SERIES_CREATE_TITLE',
            'series-details': 'TEXT_PREPAID_SERIES_DETAILS_TITLE'
        };

        var templateSources = {
            series: 'app/pages/prepaid/prepaid.series.view.html',
            cards: 'app/pages/prepaid/prepaid.cards.view.html',
            accounts: 'app/pages/prepaid/prepaid.accounts.view.html',
            categories: 'app/pages/prepaid/prepaid.categories.view.html',
            services: 'app/pages/prepaid/prepaid.services.view.html',
            create: '',
            'account-create': 'app/pages/prepaid/prepaid.accounts.edit.view.html',
            'account-edit': 'app/pages/prepaid/prepaid.accounts.edit.view.html',
            'category-create': 'app/pages/prepaid/prepaid.category.edit.view.html',
            'category-edit': 'app/pages/prepaid/prepaid.category.edit.view.html',
            'service-create': 'app/pages/prepaid/prepaid.service.edit.view.html',
            'service-edit': 'app/pages/prepaid/prepaid.service.edit.view.html',
            'series-create': 'app/pages/prepaid/prepaid.series.edit.view.html',
            'series-edit': 'app/pages/prepaid/prepaid.series.edit.view.html',
            'series-duplicate': 'app/pages/prepaid/prepaid.series.edit.view.html',
            'series-details': 'app/pages/prepaid/prepaid.series.details.view.html'
        };

        $scope.limitPerLoyaltyPeriodEnum = [
            {id: 'all-card-time', title: 'TITLE-all-card-time'},
            {id: 'hour', title: 'Hour'},
            {id: 'day', title: 'Day'},
            {id: 'month', title: 'Month'}
        ];

        $scope.accountPrecisseionEnum = [
            {id: 'integer', title: 'TITLE-integer'},
            {id: 'two-decimal-places', title: 'TITLE-two-decimal-places'},
            {id: 'three-decimal-places', title: 'TITLE-three-decimal-places'}
        ];

        $scope.multilang = MultilanguageHelper();
        $scope.getPages = getTotalPaginatedPages;
        $scope.isSupportUserExternalId = false;

        var block_form_edit = null,
            block_data_list = null,
            block_batch_coupon_list = null,
            loadingPromisesComplete = {};

        $scope.platformSupportedLanguagesCodes = Object.keys(LANGS) || [];
        SettingsService.GetPlatformParams(function (success, response) {
            SettingsService.GetPlatformSupportedLanguages(function (success, response) {
                console.log('GetPlatformSupportedLanguages', response);
                $scope.platformSupportedLanguagesCodes = response;
            });
            if (success) {
                $scope.isSupportUserExternalId = !!response.support_external_id_primary_identifier;

                if ($scope.isSupportUserExternalId) {
                    var preLastCols = $scope.cards_table_cols.length - 1;

                    $scope.cards_table_cols[preLastCols].data.splice(($scope.cards_table_cols[preLastCols].data.length - 1), 0, {
                        value: 'user_external_id',
                        text: 'Customer external id',
                        visible: true,
                        not_sortable: true
                    });
                }
            }
            initController();
        });

        // *********************************************************************************************
        //  MAIN PART
        // *********************************************************************************************

        /**
         * Initialize page mode by url
         */
        function initPageMode() {
            $scope._pageMode = $routeParams.mode || 'series';
            $scope.templateSource = templateSources[$scope._pageMode];

            block_form_edit = blockUI.instances.get('form_edit');
            block_data_list = blockUI.instances.get('data_list');
            block_batch_coupon_list = blockUI.instances.get('batch_coupon_list');

            $scope.isEditExistModel = $scope._pageMode.indexOf('-edit') !== -1;

            // console.log('Mode', $scope._pageMode);

            // if (isRouteMode('edit')) {
            //     if ($routeParams['tab'] && $routeParams['tab'] != 'general')
            //         $scope.currentTab = $routeParams['tab'];
            //     $scope._pageMode = ($routeParams.hasOwnProperty('loyalty_id')) ? 'edit' : 'show';
            // } else
            // if (isRouteMode('create')) $scope._pageMode = 'create';
        }

        /**
         * Page mode display different parts. Now 'show', 'create', 'edit'.
         * Use as <ANY ng-if="isPageMode('show')">
         */
        $scope.isPageMode = isPageMode;

        function isPageMode(mode) {
            return mode === $scope._pageMode;
        }

        function initController() {
            $scope.multilang.initLangs(LANGS, $rootScope.LANG);
            initPageMode();

            // No load data if this no include to current tariff
            if (!$rootScope.ENV.business.tariff.use_coupons_and_certificates) return;

            switch ($scope._pageMode) {
                case 'series':
                    doInitSeries();
                    break;

                case 'series-create':
                case 'series-edit':
                case 'series-duplicate':
                    doInitSeriesCreate();
                    break;

                case 'series-details':
                    doInitSeriesDetails();
                    break;

                case 'cards':
                    doInitCards();
                    break;

                case 'accounts':
                    doInitAccounts();
                    break;

                case 'account-create':
                case 'account-edit':
                    doInitAccountCreate();
                    break;

                case 'categories':
                    doInitCategories();
                    break;

                case 'category-create':
                case 'category-edit':
                    doInitCategoryCreate();
                    break;

                case 'services':
                    doInitServices();
                    break;
                case 'service-create':
                case 'service-edit':
                    doInitServiceCreate();
                    break;

                case 'create':
                    doCreateCard();
                    break;
            }
        }

        $scope.onPrepaidExport = function (format) {
            var isExportStopped = false;

            $scope.modalExport = $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/templates/modal.export.html',
                controllerAs: 'exportModal',
                controller: function ($uibModalInstance) {
                    $scope.exportModal = this;

                    // Прогресс загрузки в процентах
                    $scope.exportModal.exportProgress = 0.1;

                    // Количество загруженных записей
                    $scope.exportModal.downloadedDataCount = 0;

                    // Все количество загружаемых записей
                    $scope.exportModal.allDataCount = 0;

                    // Признак - находится ли экспорт на паузе
                    $scope.exportModal.isExportPaused = false;

                    $scope.exportModal.onTogglePause = function () {
                        $scope.exportModal.isExportPaused = !$scope.exportModal.isExportPaused;
                        if (!$scope.exportModal.isExportPaused) {
                            exportRequest();
                        }
                    };

                    $scope.exportModal.onStop = function () {
                        isExportStopped = true;
                        $scope.modalExport.close();
                        if ($scope.exportModal.isExportPaused) {
                            handleExportResults();
                        }
                    };

                    $scope.exportModal.onExit = function () {
                        $scope.exportModal.isExportPaused = true;
                        block_batch_coupon_list.stop();
                        $scope.data.isFilePreparing = false;
                        $uibModalInstance.close();
                    };
                }
            });
            $scope.data.exportHeaders = true;
            $scope.data.isFilePreparing = true;
            block_batch_coupon_list.start();

            var params = {
                page: 1
            };

            if ($scope._pageMode === 'series-details' && !!$routeParams.id && !!$scope.series.id) {
                params.batch_id = $scope.series.id;
            }
            params.count = $scope.params.cards.summary.total_rows_count + 1;

            var cards = [];
            var export_struct = ExportService.getTableForExcel(format, angular.copy($scope.cards_table_cols));

            function generateFile() {
                var file_name = $rootScope.ENV.business.code + '_prepaid-cards_' + moment().format('YYYY-MM-DD_HH:mm:ss');

                function create_export_struct() {
                    return new Promise(function (resolve) {
                        resolve(export_struct);
                    });
                }

                create_export_struct().then(function (export_struct) {
                    console.log('create_export_struct::export_struct', export_struct);
                    console.log('create_export_struct::cards', cards);
                    var export_data = [];
                    for (var cardsIndex in cards) {
                        var el = {};
                        for (var fieldIndex in export_struct) {
                            var fieldName, fieldValue;
                            fieldName = export_struct[fieldIndex].text;
                            console.log('create_export_struct::switch', export_struct[fieldIndex].value);
                            switch (export_struct[fieldIndex].value) {
                                case 'code':
                                    var code = cards[cardsIndex]['code'];
                                    if (cards[cardsIndex]['batch']['auto_generated_codes'] === 1) {
                                        fieldValue = $filter('limitTo')(code, 4, 0) + '-' + $filter('limitTo')(code, 4, 4) + '-' +
                                            $filter('limitTo')(code, 4, 8);
                                    } else {
                                        fieldValue = code;
                                    }

                                    break;

                                case 'user_external_id':
                                    fieldValue = '';
                                    if (!!cards[cardsIndex]['customer']) {
                                        fieldValue = cards[cardsIndex]['customer']['external_id'] || '';
                                    }

                                    break;
                                case 'user_id':
                                    fieldValue = '';
                                    if (!!cards[cardsIndex]['customer']) {
                                        fieldValue = (cards[cardsIndex]['customer']['phone'] || '') + ' - ' +
                                            (cards[cardsIndex]['customer']['name'] || '');
                                    }

                                    break;
                                case 'emitted_dt':
                                    fieldValue = $filter('date')(cards[cardsIndex]['emitted_dt'], 'medium', '+0');
                                    break;
                                case 'activated_dt':
                                    fieldValue = $filter('date')(cards[cardsIndex]['activated_dt'], 'medium', '+0');
                                    break;
                                case 'cancel_dt':
                                    fieldValue = $filter('date')(cards[cardsIndex]['cancel_dt'], 'medium', '+0');
                                    break;

                                case 'canceled':
                                    fieldValue = $filter('translate')(cards[cardsIndex]['canceled'] === 1 ? 'Yes' : 'No') || '';
                                    break;

                                case 'active':
                                    fieldValue = $filter('translate')(cards[cardsIndex]['active'] === 1 ? 'Yes' : 'No') || '';
                                    break;
                                default:
                                    fieldValue = (cards[cardsIndex][export_struct[fieldIndex].value] === null)
                                        ? ''
                                        : cards[cardsIndex][export_struct[fieldIndex].value];
                            }

                            el[fieldName] = fieldValue || '';
                        }
                        export_data.push(el);
                    }
                    console.log('create_export_struct::export_data', export_data);
                    $scope.$evalAsync(function ($scope) {
                        block_batch_coupon_list.stop();
                        $scope.data.isFilePreparing = false;
                    });

                    // параметр utf8Bom нужен для экспорта без заголовков, иначе слетает кодировка
                    switch (format) {
                        case 'XLSX':
                            alasql('SELECT * INTO XLSX("' + file_name + '.xlsx",{headers:' + $scope.data.exportHeaders +
                                ', utf8Bom:true}) FROM ?',
                                [export_data]);
                            break;
                        case 'XLS':
                            alasql('SELECT * INTO XLS("' + file_name + '.xls",{headers:' + $scope.data.exportHeaders +
                                ', utf8Bom:true}) FROM ?',
                                [export_data]);
                            break;
                        case 'CSV':
                            alasql('SELECT * INTO CSV("' + file_name + '.csv",{headers:' + $scope.data.exportHeaders +
                                ', separator:",", utf8Bom:true}) FROM ?', [export_data]);
                            break;
                    }
                });

            }

            // Номер текущей страницы с записями для загрузки
            var currentPage = 0;

            // Загруженные значения для экспорта
            var exportValues = [];

            // Количество записей загружаемых за один запрос к серверу
            var partCount = 200;
            console.log('$scope.data.summary.total_rows_count', $scope.params.cards.summary.total_rows_count);
            // Массив параметров для запросов к серверу
            var exportParams = ExportService.generateExportParams(params, $scope.params.cards.summary.total_rows_count, partCount);

            function PrepaidCards(params) {
                return new Promise(function (resolve) {
                    PrepaidService.PrepaidCards(params, function (success, response) {
                        resolve(response);
                    });
                });
            }

            // Получение следующего массива записей
            function downloadNextPage(exportParams, currentPage) {
                return new Promise(function (resolve) {

                    PrepaidCards(exportParams[currentPage]).then(function (resp) {
                        exportValues = [...exportValues, resp];
                        currentPage++;

                        ExportService.calculateExportValuesCount($scope, exportValues, $scope.params.cards.summary.total_rows_count);
                        if (!isExportStopped
                            && !$scope.exportModal.isExportPaused
                            && exportParams[currentPage]) {
                            downloadNextPage(exportParams, currentPage).then(function (response) {
                                resolve(response);
                            });
                        } else {
                            resolve({currentPage: currentPage});
                        }
                    });
                });
            }

            function exportRequest() {
                downloadNextPage(exportParams, currentPage).then(function (response) {
                    currentPage = response.currentPage;
                    if (isExportStopped || !exportParams[currentPage]) {
                        $scope.modalExport.close();
                        handleExportResults();
                    }
                });
            }

            function handleExportResults() {
                var result = {};
                result.data = [];
                result.summary = {};
                exportValues.forEach(function (value) {
                    result.data = result.data.concat(value.data);
                    result.summary = value.summary;
                });
                cards = result.data;
                generateFile();
            }

            exportRequest();
        };

        /**
         * Return current page title
         */
        $scope.getPageTitle = function () {
            if (!$scope._pageMode) return '';

            switch ($scope._pageMode) {
                case 'account-edit':
                    return $scope.account ? $scope.account.title : '';
                case 'service-edit':
                    return $scope.service ? $scope.service.title : '';
                case 'category-edit':
                    return $scope.category ? $scope.category.title : '';
                case 'series-edit':
                    return $scope.series ? $scope.series.title : '';
                case 'series-duplicate':
                    return pageTitles['series-create'];

                default :
                    return pageTitles[$scope._pageMode];
            }
        };

        /**
         * Return true is page contain 'form'. Need for set css class.
         */
        var formPages = ['create', 'account-create'];
        $scope.isFormClass = function () {
            return formPages.indexOf($scope._pageMode) !== -1;
        };

        $rootScope.$watchCollection('TIMEZONES[LANG]', function (newValue, oldValue, scope) {
            if (newValue) {
                $scope.data.timezonesList = angular.copy($rootScope.TIMEZONES[$rootScope.LANG]);
            }
            // if (newCollection[0]) {
            //     if ($scope.series)
            //         $scope.series.time_zone = itemByIndex($scope.data.timezonesList, c.time_zone).id;
            // }
        }, true);

        $scope.onChangeSeriesPager = function () {
            doInitSeries();
        };

        $scope.onChangeCodesPager = function () {
            getSeriesCodes();
        };

        // *********************************************************************************************
        //  SERIES PART
        // *********************************************************************************************

        /**
         * Initial page state for show list of Series
         */
        function doInitSeries() {
            var params = {
                only_active: !$scope.params.series.showDisabled,
                page: $scope.params.series.page,
                count: $scope.params.series.count
            };
            PrepaidService.Series(params, function (success, data) {
                if (success) {
                    console.log('Prepaid Series', data);
                    $scope.data.seriesList = data.data;
                    $scope.params.series.summary = data.summary;
                }
            });
        }

        /**
         * Event rise when use change "Show disabled"
         */
        $scope.onSeriesShowDisabled = function () {
            doInitSeries();
        };

        // *********************************************************************************************
        //  SERIES CREATE/EDIT PART
        // *********************************************************************************************

        /**
         * Get series data from server or initial default object
         */
        function _getSeries() {

            // Check completed all loading process
            if (!(loadingPromisesComplete.services && loadingPromisesComplete.timezones)) {
                return;
            }

            if ($routeParams.id) {
                PrepaidService.getSeries($routeParams.id, function (success, data) {
                    if (success) {
                        $scope.series = data;
                        $scope.params.series.emission_quantity_unlimited = data.emission_quantity_limit === 0;
                        $scope.series = dateFieldsFormat($scope.series, 'YYYY-MM-DD');

                        for (var idx in data.services) {
                            var service = itemByIndex($scope.data.servicesList, data.services[idx].id);
                            if (service) {
                                service.useInSeries = 1;
                            } else {
                                $scope.data.servicesList.push(data.services[idx]);
                                var account = itemByIndex($scope.data.accountsList, data.services[idx].account.id);
                                if (!account) {
                                    account = angular.copy(data.services[idx].account);
                                    $scope.data.accountsList.push(account);
                                }
                            }
                        }

                        // Tuning if duplicate
                        if ($scope.isPageMode('series-duplicate')) {
                            delete $scope.series.id;
                        }

                        // Store initial_amount
                        for (var idx in $scope.series.accounts) {
                            var account = itemByIndex($scope.data.accountsList, $scope.series.accounts[idx].account.id);
                            if (account) {
                                account.initial_amount = $scope.series.accounts[idx].initial_amount;
                            }
                        }

                        $scope.onServiceInSeriesClick();
                    }
                    $scope.multilang.initStrings($scope.series, ['public_title', 'public_description']);
                    block_form_edit.stop();
                });

            } else {

                $scope.series = {
                    active: 1,
                    business_id: $rootScope.ENV.business.id,
                    emission_period_begin: moment().startOf('day').utc().toDate(),
                    emission_period_end: moment().add(10, 'year').utc().toDate(),
                    emission_quantity_limit: 0,
                    expire_type: 'none',
                    auto_generated_codes: 1,
                    expire_value: 1
                };
                $scope.multilang.initStrings($scope.series, ['public_title', 'public_description']);
                $scope.params.series.emission_quantity_unlimited = true;

                SettingsService.Countries(function (success, data) {
                    if (success) {
                        var country = itemByIndex(data, $rootScope.ENV.business.country);
                        $scope.series.time_zone = country.time_zone;
                        block_form_edit.stop();
                        //console.log('country', country);
                    }
                });

            }
        }

        /**
         * Initial page state for create or edit Series
         */
        function doInitSeriesCreate() {
            block_form_edit.start();

            loadingPromisesComplete = {
                services: false,
                timezones: false
            };

            $scope.series = {};
            $scope.data.servicesList = [];
            $scope.data.accountsList = [];
            $scope.data.selectedAccountsList = [];

            // 1. Get all services. Need for set field series.services and series.accounts
            PrepaidService.Services({only_active: true}, function (success, data) {
                if (success) {
                    $scope.data.servicesList = data;
                    for (var idx in data) {
                        var account = itemByIndex($scope.data.accountsList, data[idx].account.id);
                        if (!account) {
                            account = angular.copy(data[idx].account);
                            account.initial_amount = 0;
                            $scope.data.accountsList.push(account);
                        }
                    }
                }
                loadingPromisesComplete.services = true;
                _getSeries();
            });

            // 2. Get all timezones
            SettingsService.Timezones(function (success, data) {
                loadingPromisesComplete.timezones = true;
                _getSeries();
            });
        }

        /**
         * Event call when change series parameter emission_quantity_limi
         */
        $scope.onEmissionQuantityLimitChange = function () {
            if ($scope.series.emission_quantity_limit == 0 && !$scope.params.series.emission_quantity_unlimited) {
                $scope.params.series.emission_quantity_unlimited = true;
            }
        };

        /**
         * Import external card numbers
         * @param seriesId
         * @param data
         * @param callback
         */
        function importExternalCodes(seriesId, data, callback) {
            var chunk = 20,
                total = data.length,
                sendCount = 0,
                importResult = {
                    processed: 0,
                    skipped: 0,
                    unique: 0
                };

            $scope.data.externalCodesImport = {
                status: 'inprocess',
                progress: 0,
                results: importResult
            };

            function _importPart() {
                if (total > 0) {
                    sendCount = total > chunk ? chunk : total;

                    var post_data = data.slice(total - sendCount, total);

                    PrepaidService.SeriesCodesAdd(seriesId, post_data, function (success, response) {
                        if (success) {
                            total = total - sendCount;
                            $scope.data.externalCodesImport.progress = Math.ceil(100 * (1 - total / data.length));

                            for (var field in response.operation_result)
                                importResult[field] += response.operation_result[field];

                            _importPart();
                        } else {
                            callback(success, response);
                        }
                    });
                } else {
                    $scope.data.externalCodesImport.status = 'completed';
                    callback(true, importResult);
                }
            }

            _importPart();
        }

        /**
         * Event rice when user click on button "Save and close"
         */
        $scope.onPrepaidSeriesSave = function (form, redirect) {

            var uploadSuccessFlags = {};

            function showUploadSuccess() {
                var isSuccess = true;
                for (var key in uploadSuccessFlags) {
                    isSuccess = isSuccess && uploadSuccessFlags[key];
                }

                if (isSuccess) {
                    NotifyService.Success('', true);
                    $location.path('/prepaid/series');
                }
            }

            // Call after store main info
            function handleResult(success, response) {
                if (success) {
                    // Upload image
                    if ($scope.data.image.new) {
                        uploadSuccessFlags.uploadImage = false;
                        var image = $scope.data.image.cropped || $scope.data.image.src;
                        PrepaidService.UploadSeriesPhoto(response.id, image, function (success, upload_response) {
                            if (success) {
                                uploadSuccessFlags.uploadImage = true;
                                showUploadSuccess();
                            }
                        });
                    } else {
                        if ($scope.series.image && isPageMode('series-duplicate')) {
                            uploadSuccessFlags.uploadImage = false;
                            imgToDataUrl($scope.series.image, function (dataURL) {
                                PrepaidService.UploadSeriesPhoto(response.id, dataURL, function (success, upload_response) {
                                    if (success) {
                                        uploadSuccessFlags.uploadImage = true;
                                        showUploadSuccess();
                                    }
                                });
                            });
                        }
                    }

                    // Upload codes
                    if ($scope.data.codes_list_import.length > 0) {
                        showUploadSuccess.importCodes = false;
                        importExternalCodes(response.id, $scope.data.codes_list_import, function (success, add_response) {
                            if (success) {
                                showUploadSuccess.importCodes = true;
                                showUploadSuccess();
                            }
                        });
                    }

                    // Notify about success if no upload image and codes
                    if ($scope.data.codes_list_import.length === 0 && !$scope.data.image.new) {
                        showUploadSuccess();
                    }
                }
            }

            if ($scope.data.selectedAccountsList.length === 0) {
                $scope.params.formSubmitted = true;
            }

            if (isFormValid(form)) {
                if ($scope.data.selectedAccountsList.length === 0) {
                    return;
                }

                var post_data = angular.copy($scope.series);
                post_data = dateFieldsFormat(post_data, 'YYYY-MM-DD[T]HH:mm:ss[Z]', 'YYYY-MM-DD');

                // Fill services
                post_data.services = [];
                for (var idx in $scope.data.servicesList) {
                    if ($scope.data.servicesList[idx].useInSeries) {
                        post_data.services.push({id: $scope.data.servicesList[idx].id});
                    }
                }

                // Fill accounts
                post_data.accounts = [];
                for (var idx in $scope.data.selectedAccountsList) {
                    var account = $scope.data.selectedAccountsList[idx];
                    post_data.accounts.push({
                        initial_amount: account.initial_amount,
                        account: {id: account.id}
                    });
                }

                // console.log('post_data', JSON.stringify(post_data));

                if ($scope.series.id) {
                    PrepaidService.SeriesEdit(post_data, handleResult);
                } else {
                    PrepaidService.SeriesAdd(post_data, handleResult);
                }

            }
        };

        $scope.onServiceInSeriesClick = function () {
            var newList = [];

            for (var idx in $scope.data.servicesList) {
                var service = $scope.data.servicesList[idx];
                if (service.useInSeries) {
                    var account = itemByIndex(newList, service.account.id);
                    if (!account) {
                        account = itemByIndex($scope.data.accountsList, service.account.id);
                        newList.push(account);
                    }
                }
            }
            $scope.data.selectedAccountsList = newList;
        };

        /**
         * Event rice when click Cancel button
         */
        $scope.onCancelSeriesEdit = function () {
            $location.path('/prepaid/series');
        };

        /**
         * Event rice when user click on "Import code".
         * Open dialog for enter codes.
         * @param src - Can be null or 'detail'
         */
        $scope.onExternalCodesImport = onExternalCodesImport;

        function onExternalCodesImport(src) {
            $scope.data.externalCodesImport = {};
            if (!$scope.modals.modalImportExternalCodes ||
                ($scope.modals.modalImportExternalCodes && $scope.modals.modalImportExternalCodes.closed.$$state.status === 1)) {
                $scope.modals.modalImportExternalCodes = $uibModal.open({
                    animation: true,
                    keyboard: false,
                    backdrop: 'static',
                    size: 'lg',
                    templateUrl: 'app/templates/modal.coupons.import.html',
                    controllerAs: 'popup',
                    controller: function ($uibModalInstance) {
                        var popup = this;

                        popup.batch = $scope.series;
                        popup.data = $scope.data;
                        popup.src = src;
                        popup.error = $scope.error;
                        popup.type = 'prepaid';

                        popup.model = {
                            external_codes: $scope.data.codes_list_import,
                            manual_external_codes: []
                        };
                        popup.params = {
                            external_codes: {
                                page: 1,
                                count: 40,
                                pagers: [40, 80, 160]
                            }
                        };
                        popup.data.summaryExternalCodes = {
                            total_rows_count: 0
                        };

                        popup.getPages = getTotalPaginatedPages;

                        if (popup.src === 'details')
                            popup.model.external_codes = [];

                        popup.onOkClick = function (exit) {
                            if (popup.src === 'details') {
                                $scope.error.message = null;
                                $scope.data.externalCodesImport.status = null;
                            }

                            $scope.data.codes_list_import = popup.model.external_codes;
                            $scope.modals.modalImportExternalCodes.close();
                        };

                        popup.fileChanged = function (event) {
                            var a = event.srcElement.value.split('.');
                            // $scope.status.file_type = a[a.length-1];

                            $timeout(function () {
                                alasql('SELECT * FROM FILE(?,{headers:false})', [event], function (data) {
                                    if (data) {
                                        popup.processImportData(data);
                                    }
                                });
                            })
                        };

                        popup.onFileSelect = function () {
                            var file = angular.element(document.getElementById('dataFileInput'));
                            file.val(null);
                        };

                        popup.processImportData = function (data) {
                            popup.model.external_codes = [];

                            $timeout(function () {
                                for (var i in data)
                                    Object.keys(data[i]).forEach(function (k) {
                                        popup.model.external_codes = popup.model.external_codes.concat(parseCodes(data[i][k].toString()));
                                    });

                                popup.data.summaryExternalCodes.total_rows_count = popup.model.external_codes.length;
                            }, 100);

                        };

                        popup.onImportClick = function () {
                            importExternalCodes(popup.batch.id, popup.model.external_codes, function (success, data) {
                                if (success) {
                                    getSeriesCodes();
                                } else {
                                    popup.error.message = data.message;
                                }
                            });
                        };

                        popup.onImportAgainClick = function () {
                            popup.data.externalCodesImport.status = null;
                            popup.params.external_codes = [];
                        };

                        popup.pageChange = function () {

                        };

                        popup.onCountChange = function (count) {
                            popup.params.external_codes.page = 1;
                            popup.params.external_codes.count = count;
                        };

                        popup.onRemoveCode = function (c) {
                            if (popup.model.external_codes.indexOf(c) !== -1)
                                popup.model.external_codes.splice(popup.model.external_codes.indexOf(c), 1);
                        };

                        popup.onManualyCodeAdd = function () {
                            var list = popup.model.manual_external_codes;

                            if (list.length === 1) {
                                list = parseCodes(list[0].code).map(function (code) {
                                    return {code: code};
                                });
                            }

                            if (!popup.params.external_codes)
                                popup.params.external_codes = [];

                            for (var i in list)
                                if (popup.model.external_codes.indexOf(list[i].code) === -1)
                                    popup.model.external_codes.unshift(list[i].code);

                            popup.params.external_codes.page = 1;
                            popup.model.manual_external_codes = [];
                            popup.data.summaryExternalCodes.total_rows_count = popup.model.external_codes.length;
                        };

                        popup.codesTagHandler = function (code) {
                            return {code: code};
                        };

                        function parseCodes(values) {
                            return (values || '').split(
                                new RegExp([',', ';', '\t', '\n'].join('|'), 'g')
                            ).map(function (value) {
                                return value.trim();
                            }).filter(function (value) {
                                return value.length > 0;
                            });
                        }

                        popup.pasteTagHandler = function (values) {
                            var values_list = parseCodes(values);

                            if (values_list && values_list.length > 0) {
                                values_list = values_list.filter(function (elem, index, self) {
                                    return index == self.indexOf(elem);
                                });

                                for (var i in values_list) {
                                    if (values_list[i]) {
                                        this.ngModel.$modelValue.push({code: values_list[i]});
                                    }
                                }
                            }

                            popup.onManualyCodeAdd();
                        };

                    }
                });
            }
        }

        // *********************************************************************************************
        //  SERIES DETAILS PART
        // *********************************************************************************************

        /**
         * Init page state for show Series details
         */
        function doInitSeriesDetails() {
            block_form_edit.start();
            PrepaidService.getSeries($routeParams.id, function (success, data) {
                if (success) {
                    $scope.series = data;
                    console.log('SERIES', $scope.series);

                    // No codes if auto generation
                    if (data.auto_generated_codes === 0) getSeriesCodes();
                    getSeriesCards();

                    block_form_edit.stop();
                }
            });

        }

        /**
         * Get external codes for prepaid series from server
         */
        function getSeriesCodes(series) {
            var params = {
                page: $scope.params.codes.page,
                count: $scope.params.codes.count
            };
            var external_codes_list = blockUI.instances.get('external_codes_list');
            external_codes_list.start();
            PrepaidService.SeriesCodes(series ? series.id : $scope.series.id, params, function (success, data) {
                if (success) {
                    console.log('Codes', data);
                    $scope.codesList = data.data;
                    $scope.params.codes.summary = data.summary;
                    external_codes_list.stop();
                }
            });
        }

        /**
         * Get prepaid Cards
         */
        function getSeriesCards(series) {
            var params = {
                batch_id: series ? series.id : $scope.series.id,
                // active: 0,
                // canceled: 0,
                page: $scope.params.cards.page,
                count: $scope.params.cards.count
                // sort_field: '',
                // sort_order: ''
            };
            PrepaidService.PrepaidCards(params, function (success, data) {
                if (success) {
                    console.log('Cards', data);
                    $scope.cardsList = data.data;
                    $scope.params.cards.summary = data.summary;
                }
            });
        }

        /**
         * Action switch enable/disable
         */
        $scope.onSeriesEnable = function (series) {
            var s = series || $scope.series,
                params = {
                    id: s.id,
                    active: s.active === 1 ? 0 : 1
                };
            PrepaidService.SeriesEdit(params, function (success, data) {
                if (success) {
                    s.active = data.active;
                    NotifyService.Success('', true);
                }
            });
        };

        /**
         * Event rice when user can generate prepaid cards.
         * Open dialog for enter cards count
         * @param series
         */
        $scope.onGenerateCards = onGenerateCards;

        function onGenerateCards(series) {
            var s = series || $scope.series;

            $scope.data.cardsGeneration = {
                status: false,
                progress: 0
            };

            $scope.modals.modalGenerateCards = $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                size: 'md',
                templateUrl: 'app/templates/modal.generate.prepaid.cards.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;

                    popup.model = {
                        count: undefined
                    };
                    popup.batch = s;
                    popup.data = $scope.data;
                    popup.type = 'generate_coupons';

                    popup.getPossibleEmittionQuantity = function () {
                        return popup.batch.emission_quantity_limit === 0
                            ? 10000
                            : s.emission_quantity_limit - s.emitted_quantity;
                        return 1;
                    };

                    popup.onOkClick = function (form) {
                        if (form && form.$valid) {
                            generateCards(s.id, popup.model, function (success, response) {
                                if (success) {
                                    getSeriesCards();

                                    // Need update status of emitted codes
                                    if (popup.batch.auto_generated_codes === 0) getSeriesCodes();

                                    NotifyService.Success('', false);
                                    $scope.modals.modalGenerateCards.close();
                                }
                            });
                        }
                    };

                    popup.onCancelClick = function (exit) {
                        popup.onRequestAbort();
                        $scope.modals.modalGenerateCards.close();
                    };

                    popup.onRequestAbort = function () {
                        popup.data.cardsGeneration.status = false;
                        popup.data.cardsGeneration.progress = 0;
                    };
                }
            });
        };

        /**
         *
         * @param series_id
         * @param quantity
         * @param callback
         */
        function generateCards(series_id, post_data, callback) {
            var chunk = 2,
                total = post_data.count,
                params = {};

            $scope.data.cardsGeneration.status = true;

            function _generatePart() {
                if (total > 0) {
                    params = {
                        count: total > chunk ? chunk : total,
                        referral_code: post_data.referral_code
                    };
                    PrepaidService.GenerateCards(series_id, params, function (success, data) {
                        if (success) {
                            total = total - params.count;
                            $scope.data.cardsGeneration.progress = Math.ceil(100 * (1 - total / post_data.count));
                            _generatePart();
                        } else {
                            $scope.data.cardsGeneration.status = false;
                            callback(false, data);
                        }
                    });
                } else {
                    $scope.data.cardsGeneration.status = false;
                    callback(true, {});
                }
            }

            _generatePart();
        }

        $scope.onExternalCodeDelete = function (code) {
            PrepaidService.SeriesCodeDelete($scope.series.id, code, function (success, response) {
                if (success) {
                    // update codes list
                    NotifyService.Success('', false);
                    getSeriesCodes();
                }
            });
        };

        // *********************************************************************************************
        //  CARDS PART
        // *********************************************************************************************

        /**
         * Init page state for show all cards
         */
        function doInitCards() {
            PrepaidService.PrepaidCards($scope.params.cards, function (success, data) {
                if (success) {
                    console.log('Prepaid Cards', data);
                    $scope.cardsList = data.data;
                    $scope.params.cards.summary = data.summary;
                }
            });
        }

        $scope.onChangeCardsPager = function () {
            if (isPageMode('cards')) {
                doInitCards();
            } else {
                getSeriesCards();
            }
        };

        /**
         * Share card to socials networks or copy share link
         * @param card
         * @param series
         */
        $scope.onShareCard = function (card, series) {
            // getCoupon(coupon.code, function(success, response) {
            $scope.modalCouponShare = $uibModal.open({
                animation: true,
                keyboard: true,
                size: 'md',
                templateUrl: 'app/templates/modal.item.share.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;

                    // popup.coupon = coupon;
                    // for(var i in response)
                    //     popup.coupon[i] = response[i];

                    popup.model = {
                        share: {
                            text: series.public_title + ' ',
                            tags: 'discount, sale, coupon, gift, ' + appConfig.platformParams.platform_name[$rootScope.LANG] +
                                ', LoyaltyPays',
                            image: series.image || 'assets/img/dummy_prepaid_series.png',
                            link: 'https://' + appConfig.platformParams.client_site[$rootScope.LANG] + '/prepaid/show/' + card.code +
                                '?lang=' +
                                $rootScope.LANG,
                            title: series.public_title,
                            description: series.public_description
                        }
                    };

                    popup.onCopyLink = function () {
                        $scope.modalCouponShare.close();
                    };

                    popup.onCancelClick = function () {
                        $scope.modalCouponShare.close();
                    };
                }
            });
            // });
        };

        /**
         * Open dialog for print card
         * @param card
         */
        $scope.onPrintCard = function (card) {
            // getCoupon(coupon.code, function(success, response) {
            $scope.modalCouponPrint = $uibModal.open({
                animation: true,
                keyboard: true,
                size: 'lg',
                templateUrl: 'app/templates/modal.prepaid.card.print.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;

                    popup.card = card;

                    popup.onItemPrint = function () {
                        var printContents = document.getElementById('printable-item').innerHTML,
                            canvas_qr_dataurl = document.getElementsByTagName('canvas')[0].toDataURL(),
                            canvas_string = '<canvas class="qrcode" height="512" width="512"></canvas>',
                            popupWin = window.open('', '_blank',
                                'screenX=1,screenY=1,left=1,top=1,' + 'width=' + screen.availWidth + ',height=' + screen.availHeight);

                        printContents = printContents.replace(canvas_string, '<img src="' + canvas_qr_dataurl + '">');

                        popupWin.document.open();
                        popupWin.document.write('<html><head><base href="/"><title></title>' +
                            '<link href="assets/print/print_item.min.css" rel="stylesheet"/></head>' +
                            '<body>' + printContents + '</body></html>');
                        popupWin.focus();
                        // setTimeout(function () {
                        //     popupWin.document.execCommand('print');
                        //     popupWin.print();
                        //     popupWin.document.close();
                        //     popupWin.close();
                        // }, 10);
                        var count = popupWin.document.querySelectorAll('img, link').length;

                        function printOnLoad() {
                            setTimeout(function () {
                                popupWin.focus();
                                popupWin.document.execCommand('print');
                                // popupWin.print();
                                popupWin.document.close();
                                popupWin.close();
                            }, 200);
                        }

                        if (count) {
                            popupWin.document.querySelectorAll('img, link').forEach(function (el) {
                                el.onload = function () {
                                    if (!--count) {
                                        printOnLoad();
                                    }
                                };
                            });
                        } else {
                            printOnLoad();
                        }
                    };

                    popup.isDateExpired = function (expire_date) {
                        var ed = new Date(expire_date),
                            cd = new Date();

                        ed.setHours(0, 0, 0, 0);
                        cd.setHours(0, 0, 0, 0);

                        return (ed < cd);
                    };

                    popup.onCancelClick = function () {
                        $scope.modalCouponPrint.close();
                    };
                }
            });
            // });
        };

        /**
         * Disable (canceled) card
         */
        $scope.onCardDisable = function (card) {
            PrepaidService.CardCancel(card.id, function (success, response) {
                if (success) {
                    card.canceled = response.canceled;
                    NotifyService.Success('', false);
                }
            });
        };

        // *********************************************************************************************
        //  CREATE CARD PART
        // *********************************************************************************************

        // function doCreateCard() {
        //
        // }

        // *********************************************************************************************
        //  ACCOUNTS PART
        // *********************************************************************************************

        function doInitAccounts() {
            var params = {
                only_active: !$scope.params.accounts.showDisabled
            };
            block_data_list.start();
            PrepaidService.Accounts(params, function (success, data) {
                if (success) {
                    console.log('Prepaid  Accounts', data);
                    $scope.data.accountsList = data;
                }
                block_data_list.stop();
            });
        }

        /**
         * Show/Hide disabled accounts
         */
        $scope.onAccountsShowDisabledClick = function () {
            doInitAccounts();
        };

        /**
         * Accounts enable/disable click
         */
        $scope.onAccountToggleClick = function (account) {
            block_data_list.start();
            var post_data = {
                id: account.id,
                active: account.active == 1 ? 0 : 1
            };
            PrepaidService.AccountEdit(post_data, function (success, data) {
                if (success) {
                    NotifyService.Success('', false);
                    account.active = data.active;
                }
                block_data_list.stop();
            });
        };

        $scope.onMakeAccountClick = function () {
            $location.path('/prepaid/account-create');
        };

        // *********************************************************************************************
        //  CREATE/EDIT ACCOUNT PART
        // *********************************************************************************************

        function doInitAccountCreate() {
            if ($routeParams.id) {
                // Edit mode
                block_form_edit.start();
                PrepaidService.getAccount($routeParams.id, function (success, data) {
                    if (success) {
                        $scope.account = data;
                        $scope.multilang.initStrings(data, ['public_title']);
                    } else {
                        // TODO Show error
                        $location.path('/prepaid/accounts');
                    }
                    block_form_edit.stop();
                });
            } else {
                $scope.account = {
                    active: 1,
                    precision: 'integer',
                    business_id: $rootScope.ENV.business.id
                };
                $scope.multilang.initStrings($scope.account, ['public_title']);
            }
        }

        /**
         * Saving created account
         */
        $scope.onAccountSave = function (form, redirect) {
            console.info('FORM', form);

            function handleResult(success, response) {
                if (success) {
                    NotifyService.Success('', true);
                    if (redirect)
                        $location.path('/prepaid/accounts');
                }
            }

            if (form.title.$valid && form.public_title.$valid) {
                if ($scope.account.id) {
                    PrepaidService.AccountEdit($scope.account, handleResult);
                } else {
                    PrepaidService.AccountAdd($scope.account, handleResult);
                }
            } else {
                form.public_title.$dirty =
                    form.title.$dirty = true;
            }
        };

        /**
         * Cancel editing
         */
        $scope.onCancelEditAccount = function () {
            $location.path('/prepaid/accounts');
        };

        /**
         * Event receive when change editing language
         */
        $scope.onChangeLanguage = function (new_lang) {
            $scope.multilang.selected(new_lang);
        };

        // *********************************************************************************************
        //  CATEGORIES PART
        // *********************************************************************************************

        function doInitCategories() {
            var params = {
                only_active: !$scope.params.categories.showDisabled
            };
            PrepaidService.Categories(params, function (success, data) {
                if (success) {
                    $scope.categoriesList = data;
                    console.log('Prepaid  Categories', data);
                }
            });
        }

        $scope.onCategoryToggle = function (category) {
            block_data_list.start();
            var post_data = {
                id: category.id,
                active: category.active == 1 ? 0 : 1
            };
            PrepaidService.CategoryEdit(post_data, function (success, data) {
                if (success) {
                    NotifyService.Success('', false);
                    category.active = data.active;
                }

                block_data_list.stop();
            });
        };

        /**
         * Back to categories list
         */
        $scope.onCreateCategoryClick = function () {
            $location.path('/prepaid/category-create');
        };

        /**
         * Show/Hide disabled categories
         */
        $scope.onCategoriesShowDisabledClick = function () {
            doInitCategories();
        };

        /**
         * Save categories order
         */
        var firstPromise = false;
        $scope.onSaveCategoriesClick = function () {
            firstPromise = true;
            for (var i = 0; i < $scope.categoriesList.length; i++) {
                if (i !== $scope.categoriesList[i].order) {
                    var post_data = angular.copy($scope.categoriesList[i]);
                    post_data.order = i;
                    PrepaidService.CategoryEdit(post_data, function (success, data) {
                        if (firstPromise && success) {
                            NotifyService.Success('', false);
                            firstPromise = false;
                        }
                    });
                }
            }
        };

        // *********************************************************************************************
        //  CATEGORY CREATE/EDIT PART
        // *********************************************************************************************

        function doInitCategoryCreate() {
            if ($routeParams.id) {
                // Edit mode
                block_form_edit.start();
                PrepaidService.getCategory($routeParams.id, function (success, data) {
                    if (success) {
                        $scope.category = data;
                        $scope.multilang.initStrings(data, ['public_title']);
                    } else {
                        // TODO Show error
                        $location.path('/prepaid/categories');
                    }
                    block_form_edit.stop();
                });
            } else {
                $scope.category = {
                    active: 1,
                    business_id: $rootScope.ENV.business.id
                };
                $scope.multilang.initStrings($scope.category, ['public_title']);
            }
        }

        /**
         * Saving created Category
         */
        $scope.onCategorySave = function (form, redirect) {
            console.info('FORM', form);

            function handleResult(success, response) {
                if (success) {
                    NotifyService.Success('', true);
                    if (redirect)
                        $location.path('/prepaid/categories');
                }
            }

            if (form.title.$valid && form.public_title.$valid) {
                if ($scope.category.id) {
                    PrepaidService.CategoryEdit($scope.category, handleResult);
                } else {
                    PrepaidService.CategoryAdd($scope.category, handleResult);
                }
            } else {
                form.public_title.$dirty =
                    form.title.$dirty = true;
            }
        };

        $scope.onCancelEditCategory = function () {
            $location.path('/prepaid/categories');
        };

        // *********************************************************************************************
        //  SERVICES PART
        // *********************************************************************************************

        function doInitServices() {
            block_data_list.start();

            PrepaidService.Services($scope.params.services, function (success, data) {
                if (success) {
                    console.log('Prepaid Services', data);
                    $scope.data.servicesList = data;
                }
                block_data_list.stop();
            });
        }

        $scope.onServiceToggleClick = function (service) {
            block_data_list.start();
            var post_data = {
                id: service.id,
                active: service.active == 1 ? 0 : 1
            };
            PrepaidService.ServiceEdit(post_data, function (success, data) {
                if (success) {
                    NotifyService.Success('', false);
                    service.active = data.active;
                }

                block_data_list.stop();
            });
        };

        $scope.onMakeServiceClick = function () {
            $location.path('/prepaid/service-create');
        };

        // *********************************************************************************************
        //  SERVICE CREATE/EDIT PART
        // *********************************************************************************************

        /**
         * Initial Service object. Load from server or init default.
         */
        function _geService() {
            var isComplete = true;
            for (var key in loadingPromisesComplete) {
                isComplete = isComplete && loadingPromisesComplete[key];
            }
            if (!isComplete) return;

            if ($routeParams.id) {
                // Edit mode
                PrepaidService.getService($routeParams.id, function (success, data) {
                    if (success) {
                        $scope.service = data;
                        $scope.data.account_id = data.account.id;
                        $scope.data.category_id = data.category ? data.category.id : null;
                        $scope.multilang.initStrings($scope.service, ['public_title', 'public_description']);

                        $scope.params.service = {
                            usage_limit_per_loyalty_unlimited: $scope.service.usage_limit_per_loyalty == 0,
                            usage_limit_per_pos_unlimited: $scope.service.usage_limit_per_pos == 0
                        };

                        PrepaidService.getServicePos(data.id, function (success, data) {
                            $scope.data.posInSevice = data.data;
                            console.log('posInSevice set', $scope.data.posInSevice);

                            block_form_edit.stop();
                        });
                    } else {
                        // TODO Show error ?
                        $location.path('/prepaid/categories');
                    }

                });
            } else {
                // Default values
                $scope.service = {
                    active: 1,
                    business_id: $rootScope.ENV.business.id,
                    usage_limit_per_loyalty_period_type: 'all-card-time',
                    usage_limit_per_loyalty_period_value: 1,
                    usage_limit_per_loyalty: 0,
                    usage_limit_per_pos_period_type: 'all-card-time',
                    usage_limit_per_pos_period_value: 1,
                    usage_limit_per_pos: 0
                };
                $scope.params.service = {
                    usage_limit_per_loyalty_unlimited: true,
                    usage_limit_per_pos_unlimited: true
                };
                $scope.multilang.initStrings($scope.service, ['public_title', 'public_description']);
                $scope.data.posInSevice = [];
                console.log('posInSevice set', $scope.data.posInSevice);

                block_form_edit.stop();
            }
        }

        /**
         * Init page state for create/edit Service (Услугу)
         */
        function doInitServiceCreate() {
            block_form_edit.start();

            $scope.params.series.emission_quantity_unlimited = true;
            $scope.params.services.modifiedPosInSevice = false;
            loadingPromisesComplete = {
                pos: false,
                accounts: false,
                categories: false
            };

            PrepaidService.Accounts({only_active: isPageMode('series-create')}, function (success, data) {
                $scope.data.accountsList = success ? data : [];
                loadingPromisesComplete.accounts = true;
                _geService();
            });

            PrepaidService.Categories({only_active: isPageMode('series-create')}, function (success, data) {
                $scope.data.categoriesList = success ? data : [];
                loadingPromisesComplete.categories = true;
                _geService();
            });

            // 3. Get all POS-es. Need for add
            SelectService.getLPList(function (data) {
                $scope.data.posList = data;
                loadingPromisesComplete.pos = true;
                _geService();
            });

            $scope.$watch('data.posInSevice', function (newValue, oldValue) {
                // This expression check if field modified
                if (Array.isArray(oldValue) && Array.isArray(oldValue)) {
                    $scope.params.services.modifiedPosInSevice = true;
                }
            });
        }

        /**
         * Raised when user select local file
         * @param evt
         */
        $scope.handleFileSelect = function (evt) {
            var file = evt.currentTarget.files[0],
                reader = new FileReader();

            var imageType = file.type,
                isPng = imageType === 'image/png';

            reader.onload = function (e) {
                var img = new Image();

                img.onload = function () {
                    var canvas = document.getElementById('file-canvas'),
                        ctx = canvas.getContext('2d'),
                        width = img.width,
                        height = img.height,
                        maxAllowedSize = 2 * 1024 * 1024;

                    canvas.width = width;
                    canvas.height = height;
                    ctx.clearRect(0, 0, width, height);
                    ctx.drawImage(img, 0, 0, width, height);

                    var resizedImageDataUrl;

                    if (isPng) {
                        resizedImageDataUrl = canvas.toDataURL('image/png');
                    } else {
                        resizedImageDataUrl = canvas.toDataURL('image/jpeg', 1);
                    }

                    if (resizedImageDataUrl.length > maxAllowedSize) {
                        var scale = 0.95,
                            quality = 1;

                        do {
                            width = Math.round(img.width * scale);
                            height = Math.round(img.height * scale);

                            canvas.width = width;
                            canvas.height = height;
                            ctx.clearRect(0, 0, width, height);
                            ctx.drawImage(img, 0, 0, width, height);

                            if (isPng) {
                                resizedImageDataUrl = canvas.toDataURL('image/png');
                            } else {
                                quality = Math.max(quality - 0.05, 0.1);
                                resizedImageDataUrl = canvas.toDataURL('image/jpeg', quality);
                            }

                            scale -= 0.05;
                        } while (
                            resizedImageDataUrl.length > maxAllowedSize &&
                            width > 50 && height > 50
                            );
                    }

                    $scope.$apply(function () {
                        $scope.data.image.new = true;
                        $scope.data.image.src = resizedImageDataUrl;
                    });
                };
                img.src = e.target.result;
            };

            reader.readAsDataURL(file);
        };

        /**
         *
         */
        $scope.initImgCrop = function () {
            var file = angular.element(document.getElementById('picture'));
            file.on('change', $scope.handleFileSelect);
        };

        $scope.setDefaultImage = function () {
            $scope.data.image.new = false;
            $scope.data.image.cropped = '';
            $scope.data.image.src = '';
        }

        $scope.cropImage = function () {
            $uibModal.open({
                animation: false,
                keyboard: true,
                backdrop: 'static',
                templateUrl: 'app/templates/modal.crop-image.html',
                controllerAs: 'popup',
                windowTopClass: 'modal-full',
                controller: function ($uibModalInstance) {
                    var popup_crop = this;
                    popup_crop.image = angular.copy($scope.data.image);

                    popup_crop.onCancelClick = function () {
                        $uibModalInstance.close();
                    }

                    popup_crop.onCropImage = function () {
                        $scope.data.image = angular.copy(popup_crop.image);
                        $uibModalInstance.close();
                    }
                }
            })
        };

        /**
         * Save new or modified service
         */
        $scope.onServiceSave = function (form, redirect) {
            console.info('FORM', form);

            // Save POS-es only if list modified
            function _storePosInService(id) {
                if ($scope.params.services.modifiedPosInSevice) {
                    $scope.data.posInSevice.forEach(function (pos) {
                        var oldPos = JSON.parse(JSON.stringify(pos));
                        pos.public_title = {};
                        pos.public_title[$rootScope.LANG] = oldPos.public_title;

                        pos.public_description = {};
                        pos.public_description[$rootScope.LANG] = oldPos.public_description;

                        pos.addresses = {};
                        pos.addresses[$rootScope.LANG] = oldPos.addresses;
                        // pos.public_title = {[$rootScope.LANG]: pos.public_title};
                        // pos.public_description = {[$rootScope.LANG]: pos.public_description};
                        //pos.addresses = {[$rootScope.LANG]: pos.addresses};
                    });
                    PrepaidService.ServicePosEdit(id, $scope.data.posInSevice, function (success, data) {
                        if (success) {
                            NotifyService.Success('', true);
                        }
                        $location.path('/prepaid/services');
                    });
                } else {
                    NotifyService.Success('', true);
                    $location.path('/prepaid/services');
                }
            }

            // Handler result of add or edit service
            function handleResult(success, response) {
                if (success) {
                    if ($scope.data.image.new) {
                        var image = $scope.data.image.cropped || $scope.data.image.src;
                        PrepaidService.UploadServicePhoto(response.id, image, function (success, upload_response) {
                            if (success) {
                                $scope.service.image = upload_response.image;
                                _storePosInService(response.id);
                            }
                        });
                    } else {
                        _storePosInService(response.id);
                    }
                }
            }

            if (isFormValid(form)) {
                var post_data = angular.copy($scope.service);
                post_data.account = {
                    id: $scope.data.account_id
                };
                if ($scope.data.category_id) {
                    post_data.category = {
                        id: $scope.data.category_id
                    };
                }

                if (form.title.$valid && form.public_title.$valid) {
                    if ($scope.service.id) {
                        PrepaidService.ServiceEdit(post_data, handleResult);
                    } else {
                        PrepaidService.ServiceAdd(post_data, handleResult);
                    }
                } else {
                    form.public_title.$dirty =
                        form.title.$dirty = true;
                }
            }

        };

        /**
         * Event call when change series parameter usage_limit_per_loyalty
         */
        $scope.onUsageLimitPerLoyaltyChange = function () {
            if ($scope.service.usage_limit_per_loyalty == 0 && !$scope.params.service.usage_limit_per_loyalty_unlimited) {
                $scope.params.service.usage_limit_per_loyalty_unlimited = true;
            }
        };

        /**
         * Event call when change series parameter usage_limit_per_pos
         */
        $scope.onUsageLimitPerPosChange = function () {
            if ($scope.service.usage_limit_per_pos == 0 && !$scope.params.service.usage_limit_per_pos_unlimited) {
                $scope.params.service.usage_limit_per_pos_unlimited = true;
            }
        };

        /**
         * Event call when user change options 'params.service.usage_limit_per_loyalty_unlimited'
         */
        $scope.onServiceUsageLoyaltyUnlimitedClick = function () {
            $scope.service.usage_limit_per_loyalty = $scope.params.service.usage_limit_per_loyalty_unlimited ? 0 : 1;
            if ($scope.params.service.usage_limit_per_loyalty_unlimited) {
                $scope.service.usage_limit_per_loyalty_period_type = 'all-card-time';
            }
        };

        /**
         * Event call when user change options 'params.service.usage_limit_per_loyalty_unlimited'
         */
        $scope.onServiceUsagePosUnlimitedClick = function () {
            $scope.service.usage_limit_per_pos = $scope.params.service.usage_limit_per_pos_unlimited ? 0 : 1;
            if ($scope.params.service.usage_limit_per_pos_unlimited) {
                $scope.service.usage_limit_per_pos_period_type = 'all-card-time';
            }
        };

        /**
         *
         * @param account
         * @returns {number}
         */
        $scope.getStepDigsByAccountId = function (accountId) {
            return $scope.getStepDigsByAccount(itemByIndex($scope.data.accountsList, accountId));
        };

        $scope.getStepDigsByAccount = function (account) {
            if (account) {
                switch (account.precision) {
                    case 'integer':
                        return 1;
                    case 'two-decimal-places':
                        return 0.01;
                    case 'three-decimal-places':
                        return 0.001;
                }
            }
            return 1;
        };

        $scope.getPatternDigsByAccountId = function (accountId) {
            return $scope.getPatternDigsByAccount(itemByIndex($scope.data.accountsList, accountId));
        };

        $scope.getPatternDigsByAccount = function (account) {
            if (account) {
                switch (account.precision) {
                    case 'integer':
                        return '\d+';
                    case 'two-decimal-places':
                        return '\d+.\d{2}';
                    case 'three-decimal-places':
                        return '\d+.\d{3}';
                }
            }
            return '\d+';
        };

        $scope.getPlaceholderDigsByAccountId = function (accountId) {
            return $scope.getPlaceholderDigsByAccount(itemByIndex($scope.data.accountsList, accountId));
        };

        $scope.getPlaceholderDigsByAccount = function (account) {
            if (account) {
                switch (account.precision) {
                    case 'integer':
                        return '0';
                    case 'two-decimal-places':
                        return '0.00';
                    case 'three-decimal-places':
                        return '0.000';
                }
            }
            return '0';
        };

        /**
         * Back to services list
         */
        $scope.onCancelEditService = function () {
            $location.path('/prepaid/services');
        };

    }
})();
